import React, { useState, useEffect, Fragment, lazy } from "react";
import { EditableArea } from "@magnolia/react-editor";
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import { useLocation } from "react-router-dom";
import { useDetailPageQuery } from "../../../utils/location";
import { getMagnoliaContext } from "../../../magnolia.service";
import { DYNAMIC_PAGE_QUERY_KEYS } from "../../../utils/constants/pagePaths";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import Product from "../../../components/magnolia/productDetail/ProductDetail";
import { getProduct } from "../../../services/products.service";
import { parseRef } from "../../../utils/refs";
import { getProductDecoration } from "../../../services/productDecorations.service";

const ProductDetail = ({ currentLanguageCode, previewItem, main, title, meta, geo }) => {
    const location = useLocation();
    const magnoliaContext = getMagnoliaContext(location);
    const [product, setProduct] = useState({});
    const [decoration, setDecoration] = useState(null);
    // URL carries either:
    //   /product/<name>                       (legacy / JCR — name-based lookup)
    //   /product/<id>?source=salesforce-sfcc  (multi-source — external endpoint)
    let { id: productId, source } = useDetailPageQuery(DYNAMIC_PAGE_QUERY_KEYS["PRODUCT_DETAIL"]);

    // If the productId is not set and we are in the edit mode, use previewItem value
    if (!productId && magnoliaContext.isMagnoliaEdit && previewItem) {
        ({ productId, source } = parseRef(previewItem) || {});
    }

    useEffect(() => {
        async function fetchData() {
            const productNode = await getProduct({ lang: currentLanguageCode, source, productId });

            if (productNode) setProduct(productNode);

            // Optional enrichment (3D/AR model, extra description, images) keyed by source + productId.
            setDecoration(await getProductDecoration({ source, productId }));
        }

        if (!productId) return;

        fetchData();
    }, [currentLanguageCode, productId, source]);

    return (
        <Fragment>
            <HtmlHeader title={product ? product.displayName || product["@name"] : title} meta={meta} geo={geo} />
            <Breadcrumb />
            <Product product={product} source={source} decoration={decoration} />
            {main && <EditableArea content={main} />}
        </Fragment>
    );
};

export default connect()(multilanguage(ProductDetail));
